import { FormValueScope } from '@epages/react-components'
import { useSelector } from 'react-redux'
import Immutable from 'immutable'

import { useTranslate } from '../../utils/translate'
import CheckboxField from '../formComponents/CheckboxField'
import FormGroup from '../formComponents/FormGroup'

export default function FooterCopyrightSettings() {
  const t = useTranslate('interface', 'components.bottomBar.footerSettings.copyright')
  const isCopyrightActive = useSelector<State, boolean>((state) =>
    state.getIn(['shop', 'userSettings', 'copyright', 'active']),
  )

  const copyrightText = useSelector<State, string>((state) =>
    state.getIn(['shop', 'userSettings', 'copyright', 'text']),
  )

  return (
    <div className="dali-settingslayer-element ep-footer-copyright">
      <div className="ep-form-row">{t('description')}</div>
      <div className="ep-form-row">
        <FormValueScope name="copyright">
          <FormGroup
            name="active"
            className="ep-form-row-no-margin"
            label={t('label')}
            info={t('tooltip')}
            tagName="label"
            labelAfterComponent
          >
            <CheckboxField name="active" />
          </FormGroup>
        </FormValueScope>
        <input
          name="text"
          type="text"
          className="ep-form-text-field"
          value={copyrightText}
          readOnly={true}
          disabled={!isCopyrightActive}
        />
      </div>
    </div>
  )
}

FooterCopyrightSettings.defaultValue = {
  copyright: Immutable.fromJS({ active: false }),
}
